import { SupabaseClient } from "@supabase/supabase-js";

export interface EmailSignup {
  id: string;
  email: string;
  first_name: string | null;
  created_at: string;
}

/**
 * Insert a new email signup record.
 *
 * @param client - Supabase client
 * @param email - Email address to add
 * @param firstName - Optional first name
 * @returns The created record
 */
export interface CreateEmailSignupResult {
  record: EmailSignup;
  alreadyExists: boolean;
}

export async function createEmailSignup(
  client: SupabaseClient,
  email: string,
  firstName?: string,
): Promise<CreateEmailSignupResult> {
  const { data: existing } = await client
    .from("email_signups")
    .select("*")
    .eq("email", email)
    .maybeSingle();

  if (existing) {
    return { record: existing as EmailSignup, alreadyExists: true };
  }

  const { data, error } = await client
    .from("email_signups")
    .insert({ email, first_name: firstName })
    .select("*")
    .single();

  if (error) {
    throw error;
  }

  if (!data) {
    throw new Error("Failed to create email signup");
  }

  return { record: data as EmailSignup, alreadyExists: false };
}
